import { axiosApi, baseURL } from "../../../../../api/dbAxios";
import { newUserRoleBody } from "./interfaces/newUserRoleBody.interface";

export const addNewSuperuser = async (
  name: string | null,
  email: string,
  id: number,
) => {
  const body = {
    is_superuser: true,
    name,
    email,
  };

  try {
    const response = await axiosApi.patch(`${baseURL}/users/${id}/`, body);
    return {
      ...response.data,
      right_id: 0,
      right: "Superuser",
      user: { name: response.data.name, email: response.data.email },
    };
  } catch (error) {
    console.error("Error adding new User:", error);
    return [];
  }
};
